import React, { useContext, useEffect, useState } from 'react';

import { t } from 'i18next';

import EmailPrevisualization from './sections/EmailPrevisualization/EmailPrevisualization';
import RewardsEmailModelSelector from './sections/RewardsEmailModelSelelector/RewardsEmailModelSelector';
import RewardsPointsTextArea from './sections/RewardsTextArea/RewardsPointsTextArea';
import CardNE from '../../../shared/components/CardNE/CardNE';
import { CompanyContext } from '../../../shared/context/company/companyContext';
import { useIsMounted } from '../../../shared/hooks/useIsMounted';
import Rewards from '../../../shared/services/api/rewards/rewards';
import { TRANSLATION_POINTS_BY_FILE } from '../../../shared/translations/rewards';

import './RewardsPointsEmailConfig.scss';

interface IRewardsPointsEmailConfig {
  onChangeCategory: (value: string) => void;
  onChangeMessage: (value: string) => void;
  category?: string;
  message?: string;
}

const RewardsPointsEmailConfig = ({
  onChangeCategory,
  onChangeMessage,
  category = 'default',
  message = ''
}: IRewardsPointsEmailConfig) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [template, setTemplate] = useState<string>('');

  const isMounted = useIsMounted();

  const { company } = useContext(CompanyContext);
  const changeCategory = (value: string) => {
    onChangeCategory(value);
  };

  const changeTextAreaMessage = (value: string) => {
    onChangeMessage(value);
  };

  useEffect(() => {
    const fetchTemplate = async () => {
      try {
        setLoading(true);
        const response = await Rewards.getEmailTemplate(company.id, category);
        if (isMounted) setTemplate(response);
      } catch {
        if (isMounted) setTemplate('');
      } finally {
        if (isMounted) setLoading(false);
      }
    };
    fetchTemplate();
  }, [company.id, category]);

  return (
    <CardNE className="rewards-points-emails-config" data-experience="new">
      <div className="first-element">
        <h3 className="ne-font-body-lg font-bold m-0">{t(TRANSLATION_POINTS_BY_FILE.emailsConfiguration.title)}</h3>
        <RewardsEmailModelSelector onChanged={changeCategory} value={category} />
        <RewardsPointsTextArea onChange={changeTextAreaMessage} value={message} />
      </div>
      <div className="second-element">
        <EmailPrevisualization html={template} message={message} loading={loading} />
      </div>
    </CardNE>
  );
};

export default RewardsPointsEmailConfig;
